const Footer = () => {
  const currentYear = new Date().getFullYear();

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <footer
      data-testid="footer"
      className="py-12 md:py-16 px-5 md:px-12 lg:px-20 bg-black border-t border-white/5"
    >
      <div className="max-w-6xl mx-auto">
        <div className="flex flex-col md:flex-row justify-between items-start gap-8 md:gap-12 mb-12">
          <div>
            <div className="mb-4">
              <span className="text-xl md:text-2xl tracking-tight" style={{ fontFamily: 'Montserrat, sans-serif' }}>
                <span className="text-white font-semibold">Harlem</span>
                <span className="text-[#6DBE2E] font-bold"> Leads</span>
              </span>
            </div>
            <p className="text-white/30 text-sm max-w-xs">
              Strategic outbound for those who value reputation.
            </p>
          </div>

          <div className="flex gap-12 md:gap-16">
            <div>
              <p className="text-white/50 text-[11px] font-medium tracking-[0.15em] uppercase mb-3">Navigate</p>
              <ul className="space-y-2">
                <li>
                  <button
                    onClick={() => scrollToSection("approach")}
                    className="text-white/30 hover:text-white text-sm transition-colors duration-300"
                  >
                    Approach
                  </button>
                </li>
                <li>
                  <button
                    onClick={() => scrollToSection("industries")}
                    className="text-white/30 hover:text-white text-sm transition-colors duration-300"
                  >
                    Industries
                  </button>
                </li>
                <li>
                  <button
                    onClick={() => scrollToSection("process")}
                    className="text-white/30 hover:text-white text-sm transition-colors duration-300"
                  >
                    Process
                  </button>
                </li>
              </ul>
            </div>

            <div>
              <p className="text-white/50 text-[11px] font-medium tracking-[0.15em] uppercase mb-3">Contact</p>
              <button
                onClick={() => scrollToSection("cta")}
                className="text-[#6DBE2E] text-sm hover:text-white transition-colors duration-300"
              >
                Start a Conversation
              </button>
            </div>
          </div>
        </div>

        <div className="pt-8 border-t border-white/5">
          <p className="text-white/20 text-xs">
            © {currentYear} Harlem Leads
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
